const QAdata = [
  {
    question: "How would you describe your style?",
    answer:
      "Our style has been described by many as elegant, timeless, and natural. We specialize in capturing authentic moments that unfold organically throughout your wedding day. As storytellers, we believe in being attentive, intentional, and subtle, ensuring that every detail contributes to the narrative of your love story.",
  },
  {
    question: "Do you travel Internationally?",
    answer:
      "We are based in Vancouver, Canada, but mostly we are on our wheels. We love traveling for weddings and exploring different cultures. We have documented weddings in the States, Mexico, Europe, New Zealand, and India.",
  },
  {
    question: "How far should we book you in advance?",
    answer:
      "Most of our clients book us more than a year in advance to secure their preferred date. We recommend reaching out as early as possible to increase the chances of your date being available on our calendar. To secure your date, we require a 30% retainer.",
  },
  {
    question: "How do you deliver wedding films?",
    answer:
      "We deliver all our films in an online link, accessible for a year. This allows you to share your films easily with loved ones.",
  },
  {
    question: "Woo-hoo, we are now more excited than ever, we are ready to book, what do we do now?",
    answer:
      "Once you book a consultation with us, we delve into the details of your wedding week. This allows us to understand your preferences better and showcase our unpublished and organic work. During the consultation, we discuss aspects such as required hours, next-day edits, feature films, highlights, and more. Afterward, we send you the contract for signing, and upon receiving your deposit, your dates are secured.",
  },
  {
    question: "I HAVE ANOTHER QUESTION",
    answer:
      "No problem, ask away - email us at hello@madeinheaven.ca or reach us out on our contact page.",
  },
];

export default QAdata;
